/**
 * User: danielgw
 * Date: 2/22/17
 */
define(function (require) {

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');
    var NumericInputViewController = require('web-agent-viewControllers/NumericInputViewController');

    var FilterItemMcs = BaseFilterItem.extend({
        LPElementsMap: {

        },
        LPTemplatesFiles: {
            mcs: 'LP_MCS_filter_view.html'
        },
        LPViewMap: {
            button: ".lpview_button",
            buttonClass: ".lpview_button_",
            fromInput:".start",
            toInput:".end"
        },
        LPClassesMap: {
            checked: "checked",
            button: "lpview_button_"
        },
        Range: {
            min: -100,
            max: 100
        },

        initialize: function (constructorData) {
            var radiosHTML = "";
            var textInjection;
            var iconTemplate = require("web-agent-templates/LP_filter_single_icon_text.html");
            var rangeTemplate = require("web-agent-templates/LP_filter_full_table_numeric_range.html");
            // var iconTemplate = lpUtils.loadResource("web-agent-templates/LP_filter_single_icon_text.html");
            // var rangeTemplate = lpUtils.loadResource("web-agent-templates/LP_filter_full_table_numeric_range.html");
            var positiveInjection = {
                sentiment: "positive",
                text: ""
            };
            var negativeInjection = {
                sentiment: "negative",
                text: ""
            };
            var rangeInjection = {
                filter_time_frame_from: agentLEManager.translateLE("LEWebAgent.filter_mcs_from"),
                filter_time_frame_to: agentLEManager.translateLE("LEWebAgent.filter_mcs_to")
            };

            this.buttons = [
                {
                    status: "0",
                    buttonId: "all",
                    content: agentLEManager.translateLE("LEWebAgent.all")
                },
                {
                    status: "1",
                    buttonId: "positive",
                    content: this.injectTextDefaults(iconTemplate, positiveInjection)
                },
                {
                    status: "-1",
                    buttonId: "negative",
                    content: this.injectTextDefaults(iconTemplate, negativeInjection)
                },
                {
                    status: "2",
                    buttonId: "range",
                    content: this.injectTextDefaults(rangeTemplate, rangeInjection)
                }
            ];

            var radioTemplate = require("web-agent-templates/LP_filter_single_radio_select_view.html");
            // var radioTemplate = lpUtils.loadResource("web-agent-templates/LP_filter_single_radio_select_view.html");

            for(var i= 0, l = this.buttons.length; i < l; i++){
                textInjection = this.buttons[i];
                radiosHTML += this.injectTextDefaults(radioTemplate, textInjection);
            }

            var filterTemplate = require("web-agent-templates/LP_MCS_filter_view.html");
            // var filterTemplate = lpUtils.loadResource("web-agent-templates/LP_MCS_filter_view.html");
            textInjection = {
                radio_buttons: radiosHTML
            };
            filterTemplate = this.injectTextDefaults(filterTemplate, textInjection);
            this.createView({template: filterTemplate, target: this.LPViewMap.filterArea });

            var DEFAULT_FILTER_OPTIONS = {
                from: this.Range.min,
                to: this.Range.max,
                status:"0"
            };

            this.defaultFilterUIData = lpUtils.cloneObject(constructorData.defaultFilter || DEFAULT_FILTER_OPTIONS);
            this.filterUIData = lpUtils.cloneObject(constructorData.defaultFilter || DEFAULT_FILTER_OPTIONS);
            this.config = constructorData;
        },
        events: function () {
            this.bindViewEvent({selector: this.LPViewMap.button, DOMEvent: "click", callback: this._onButtonClicked});
        },
        render: function () {

            this.fromVC = new NumericInputViewController({
                defaultInputValue: this.filterUIData.from,
                minimumInputValue: this.Range.min,
                maximumInputValue: this.Range.max,
                valueChangedCallback: this._onValueChanged.bind(this, 'from'),
                //lostFocusCallback: this.setFocus,
                context: this
            });
            this.addViewController({viewController: this.fromVC, target: this.LPViewMap.fromInput});

            this.toVC = new NumericInputViewController({
                defaultInputValue: this.filterUIData.to,
                minimumInputValue: this.Range.min,
                maximumInputValue: this.Range.max,
                valueChangedCallback: this._onValueChanged.bind(this, 'to'),
                //lostFocusCallback: this.setFocus,
                context: this
            });
            this.addViewController({viewController: this.toVC, target: this.LPViewMap.toInput});
        }
    });

    /**
     * Return obect with filter results
     * @override
     */
    FilterItemMcs.prototype.getValue = function() {

        if(_.isUndefined(this.filterUIData.status) || this.filterUIData.status === "0"){
            return undefined;
        }

        return {
            from: _.isUndefined(this.filterUIData.from) ? this.defaultFilterUIData.from : this.filterUIData.from,
            to: _.isUndefined(this.filterUIData.to) ? this.defaultFilterUIData.to : this.filterUIData.to,
            status: this.filterUIData.status
        };
    };

    /**
     * Callback for numeric field value change
     * @param {String} target start or end fields
     * @param {String} value
     * @private
     */
    FilterItemMcs.prototype._onValueChanged = function(target, value) {
        this.filterUIData[target] = value;

        if(target === "from"){
            this.toVC.setMinimumInputValue(this.filterUIData.from + 1 <= this.Range.max ? this.filterUIData.from + 1 : this.Range.max);
        } else if (target === "to"){
            this.fromVC.setMaximumInputValue(this.filterUIData.to - 1 >= this.Range.min ? this.filterUIData.to - 1 : this.Range.min);
        }
    };

    /**
     * Callback for bind on radio button click
     * @param data
     * @private
     */
    FilterItemMcs.prototype._onButtonClicked = function(data) {
        var clickedElement = data.currentTarget;

        // set filter UI data according to the selection
        for(var i= 0, l = this.buttons.length; i < l; i++){
            if (this.hasClass(clickedElement, this.LPClassesMap.button+this.buttons[i].buttonId)[0] === true) {
                this.filterUIData.status = this.buttons[i].status;
            }
        }

        // update UI
        this.updateFilterUI(this.filterUIData);
    };

    /**
     * Update the UI look base on filterUIData
     * @override
     */
    FilterItemMcs.prototype.updateFilterUI = function (filterUIData) {
        this.filterUIData = lpUtils.cloneObject(filterUIData || this.defaultFilterUIData);

        this.removeClassMultiElements(this.LPViewMap.button, this.LPClassesMap.checked);
        this.fromVC.setMaximumInputValue(this.Range.max);
        this.toVC.setMinimumInputValue(this.Range.min);
        for(var i= 0, l = this.buttons.length; i < l; i++){
            if (this.filterUIData.status === this.buttons[i].status) {
                this.addClass(this.LPViewMap.buttonClass+this.buttons[i].buttonId, this.LPClassesMap.checked);
                break;
            }
        }
        this.fromVC.setCurrentInputValue(this.filterUIData.from);
        this.toVC.setCurrentInputValue(this.filterUIData.to);

    };


    return FilterItemMcs;

});
